// Office map embed used by the desktop and mobile CompanyLocation views.
//
// REACT_APP_GOOGLE_MAPS_API_KEY is NOT a secret. CRA inlines REACT_APP_* values
// into the bundle at build time, and the key is visible in the iframe URL on the
// live page either way — a browser-side Maps Embed key cannot be hidden. Keeping
// it out of the repo is hygiene; the control that actually protects the quota is
// the restriction set on the key in Google Cloud Console (HTTP referrers limited
// to our domains, API access limited to the Maps Embed API).
//
// It lives in .env (gitignored). `yarn deploy` builds locally and uploads the
// finished build/, so that file is the production config. When the variable is
// unset we fall back to Google's keyless share embed, so the map still renders
// instead of breaking on `key=undefined`.

// 本社所在地 (2026-09-15 移転). The pin is driven by these values, not by the
// address JSON used for the text block — update them together.
//
// The keyed embed pins by place ID: Google's entry for 〒111-0041 東京都台東区
// 元浅草2丁目6−7 (35.7100595, 139.7829271), the location given for the building.
// The keyless share embed can't take a place ID, so it uses OFFICE_ADDRESS, which
// resolves to the same entry. Leave the building name off: "…2-6-7 マタイビル"
// resolves to a different entry, マタイビルディング at 2丁目6, ~9 m east.
export const OFFICE_PLACE_ID = "ChIJvTGmtaKOGGAR-uWOe7OSVEQ";
export const OFFICE_ADDRESS = "東京都台東区元浅草2-6-7";
export const OFFICE_MAP_ZOOM = 17;

export const officeMapEmbedUrl = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  return apiKey
    ? `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=place_id:${OFFICE_PLACE_ID}&zoom=${OFFICE_MAP_ZOOM}`
    : `https://maps.google.com/maps?q=${encodeURIComponent(OFFICE_ADDRESS)}&z=${OFFICE_MAP_ZOOM}&output=embed`;
};
